module.exports = __webpack_public_path__ + "img/base_patrimoine_art_deco.a5580cd3.svg";